export default function getResource(label) {
    const resources = {
        top: 'Haut',
        details: 'Détails',
        similar: 'Similaire',
        qAndA: 'Questions et réponses',
        reviews: 'Commentaires',
        navLabel: 'Navigation dans la page du produit'
    };

    return resources[label];
}
